import { CommonReport } from "components/reports/show/markup";
import { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { paths } from "helpers/paths";
import { reportFilterWrapper, SelectColumnFilter } from "helpers/reactTable";
import { formatValue, typeSpecificProps } from "helpers/reports";
import React from "react";
import { Link } from "react-router-dom";
import { getOrganizationNames } from "sources/admin";
import { list as getDrivers } from "sources/books/admin/drivers";

export default class FuelLimitsReport extends CommonReport {
    extractColumns = () => {
        return [
            this.idColumn,
            {
                Header: "Организация",
                accessor: "organizationName",
                Filter: reportFilterWrapper((props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            ...defaultMultipleSelectProps,
                            url: getOrganizationNames,
                            inputProps: { name: "organizationId" },
                            propName: "name",
                            components: { ValueContainer },
                        }}
                    />
                )),
                filter: (rows, _id, filterValue) => {
                    if (!filterValue || !filterValue.value || filterValue.value.length === 0) {
                        return rows;
                    }
                    return rows.filter((row) => filterValue.value.includes(row.values.organizationId));
                },
                Cell: ({
                    row: {
                        original: { organizationName, organizationId },
                    },
                }) =>
                    organizationName &&
                    organizationId && <Link to={paths.adminOrganizationsShow(organizationId)}>{organizationName}</Link>,
            },
            {
                Header: "ТС",
                accessor: "carNumber",
                ...typeSpecificProps({ clrType: "string" }),
            },
            {
                Header: "Водитель",
                accessor: "driverName",
                Filter: reportFilterWrapper((props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            ...defaultMultipleSelectProps,
                            url: getDrivers,
                            inputProps: { name: "driverId" },
                            propName: "fullName",
                            components: { ValueContainer },
                        }}
                    />
                )),
                filter: (rows, _id, filterValue) => {
                    if (!filterValue || !filterValue.value || filterValue.value.length === 0) {
                        return rows;
                    }
                    return rows.filter((row) => filterValue.value.includes(row.values.driverId));
                },
            },
            {
                Header: "Номер карты",
                accessor: "cardNumber",
                ...typeSpecificProps({ clrType: "string" }),
            },
            {
                Header: "Бренд АЗС",
                accessor: "gasStationBrandName",
                ...typeSpecificProps({ clrType: "string" }),
            },
            {
                Header: "Дата вызова метода",
                accessor: "date",
                ...typeSpecificProps({ clrType: "datetimeoffset" }),
                Cell: ({ value }) => formatValue(value.date, "datetimeoffset"),
            },
            {
                Header: "Вид операции",
                accessor: "type",
                ...typeSpecificProps({ clrType: "string" }),
            },
            {
                Header: "Кол-во литров",
                accessor: "volume",
                ...typeSpecificProps({ clrType: "double" }),
            },
            {
                Header: "Сумма лимита",
                accessor: "price",
                ...typeSpecificProps({ clrType: "double" }),
            },
            {
                Header: "Статус операции",
                accessor: "status",
                ...typeSpecificProps({ clrType: "string" }),
            },
            { accessor: "organizationId" },
        ];
    };

    tableExtraProps = () => {
        return {
            initialState: {
                hiddenColumns: ["organizationId", "driverId"],
            },
        };
    };
}
